import { defineMessages } from 'react-intl';

const messages = defineMessages({
  phone: {
    id: 'phone',
    defaultMessage: 'Phone',
  },
  fax: {
    id: 'fax',
    defaultMessage: 'Fax',
  },
  writeToTown: {
    id: 'writeToTown',
    defaultMessage: 'Write to us',
  },
  writeToTownUrl: {
    id: 'writeToTownUrl',
    defaultMessage:
      '/es/turismo/oficina-de-turismo/escribir-a-la-oficina-de-turismo',
  },
  privacy: {
    id: 'privacy',
    defaultMessage: 'Privacy',
  },
  privacyUrl: {
    id: 'privacyUrl',
    defaultMessage: 'privacy',
  },
  contactUrl: {
    id: 'contactUrl',
    defaultMessage: 'contact-form',
  },
  contact: {
    id: 'contact',
    defaultMessage: 'Contact',
  },
  debaTown: {
    id: 'debaTown',
    defaultMessage: 'Deba municipality',
  },
  siteMap: {
    id: 'siteMap',
    defaultMessage: 'Site Map',
  },
  siteMapUrl: {
    id: 'siteMapUrl',
    defaultMessage: 'sitemap',
  },
  office: {
    id: 'office',
    defaultMessage: 'Office',
  },
  headerOffice: {
    id: 'headerOffice',
    defaultMessage: 'Turism ',
  },
  officeUrl: {
    id: 'officeUrl',
    defaultMessage: '/en/tourism/tourist-office',
  },
  touristOffice: {
    id: 'touristOffice',
    defaultMessage: 'Tourist Office',
  },
});

export default messages;
